import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PAGES = {
  regulamin: {
    title: "Regulamin",
    subtitle: "Warunki świadczenia usług",
    sections: [
      {
        heading: "§1. Dane przedsiębiorcy",
        content: `Usługodawcą jest Spółka Cywilna działająca pod firmami:
- "Gabl.net Glam" Gabriela Bachara
- "FRYZJER ARTYSTA" Milena Bachara

Spółka Cywilna
ul. Reymonta 25, 33-100 Tarnów
NIP: 8733280376
REGON: 389339228
E-mail: fryzjerartystamilena@gmail.com
Instagram: @fryzjer_artysta

(dalej: "Usługodawca")

Korzystanie z usług oznacza akceptację niniejszego regulaminu.`,
      },
      {
        heading: "§2. Rezerwacja wizyt",
        content: `1. Rezerwacja wizyty odbywa się za pośrednictwem formularza online dostępnego na stronie internetowej lub drogą telefoniczną.

2. Każda rezerwacja wymaga potwierdzenia przez Usługodawcę w ciągu 24 godzin roboczych.

3. Klient otrzymuje potwierdzenie terminu po akceptacji rezerwacji przez Usługodawcę.

4. Niestawienie się na wizytę bez wcześniejszego odwołania może skutkować odmową realizacji kolejnej rezerwacji.`,
      },
      {
        heading: "§3. Odwołanie wizyty",
        content: `1. Odwołanie wizyty musi nastąpić co najmniej 24 godziny przed planowanym terminem.

2. Odwołania dokonuje się telefonicznie, mailowo lub przez wiadomość na Instagramie.

3. Wizyta odwołana z zachowaniem 24-godzinnego okresu nie pociąga za sobą żadnych kosztów.

4. W przypadku odwołania wizyty z krótszym wyprzedzeniem lub niestawienia się bez odwołania, Usługodawca zastrzega sobie prawo do naliczenia opłaty rezerwacyjnej.`,
      },
      {
        heading: "§4. Płatności",
        content: `1. Płatność za usługi fryzjerskie realizowana jest gotówką lub kartą w salonie, po wykonaniu usługi.

2. Zakup szkoleń i kursów możliwy jest online za pośrednictwem bramki płatności Przelewy24 (operator: PayPro SA, ul. Kanclerska 15, 60-327 Poznań, NIP 779-236-98-87) lub przelewem bankowym.

3. W przypadku szkoleń wymagany jest zadatek (wskazana kwota) płatny przy rejestracji. Pozostała kwota płatna jest na miejscu w dniu szkolenia.

4. Ceny podane na stronie internetowej są cenami orientacyjnymi i mogą ulec zmianie w zależności od specyfiki zlecenia.

5. Ostateczna cena usługi fryzjerskiej ustalana jest po konsultacji przed jej wykonaniem. Jeżeli włosy są wyjątkowo gęste, cena może być wyższa.`,
      },
      {
        heading: "§5. Reklamacje usług",
        content: `1. Klient ma prawo zgłosić reklamację usługi w terminie 7 dni od jej wykonania.

2. Reklamację należy zgłosić telefonicznie lub mailowo, opisując stwierdzone wady.

3. Usługodawca rozpatruje reklamację w terminie 14 dni roboczych.

4. W przypadku uzasadnionej reklamacji, Usługodawca zaproponuje poprawkę usługi lub zwrot części kosztów.`,
      },
      {
        heading: "§6. Postanowienia końcowe",
        content: `1. Usługodawca zastrzega sobie prawo do zmiany regulaminu. O zmianach klienci zostaną poinformowani z wyprzedzeniem.

2. W sprawach nieuregulowanych niniejszym regulaminem mają zastosowanie przepisy prawa polskiego, w szczególności Kodeksu Cywilnego.

3. Ewentualne spory rozstrzygane będą przez sąd właściwy dla siedziby Usługodawcy.`,
      },
    ],
  },
  prywatnosc: {
    title: "Polityka Prywatności",
    subtitle: "Ochrona danych osobowych (RODO)",
    sections: [
      {
        heading: "1. Administrator danych osobowych",
        content: `Administratorem Twoich danych osobowych jest Milena Bachara, prowadząca działalność pod nazwą Fryzjer Artysta, z siedzibą w Tarnowie, ul. Reymonta 25, 33-100 Małopolska.

Kontakt z Administratorem: kontakt@fryzjerartysta.pl`,
      },
      {
        heading: "2. Zakres i cel przetwarzania danych",
        content: `Przetwarzamy następujące dane osobowe:
- Imię i nazwisko, adres e-mail, numer telefonu - w celu realizacji rezerwacji wizyt i szkoleń
- Adres e-mail - w celu komunikacji dotyczącej usług i szkoleń
- Dane podane w formularzach kontaktowych - w celu udzielenia odpowiedzi na zapytania

Podstawa prawna przetwarzania: art. 6 ust. 1 lit. b RODO (niezbędność do wykonania umowy) oraz art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes Administratora).`,
      },
      {
        heading: "3. Okres przechowywania danych",
        content: `Dane osobowe przechowywane są przez okres niezbędny do realizacji usług oraz przez okres wymagany przepisami prawa (np. dokumentacja księgowa - 5 lat). Dane z formularzy kontaktowych przechowywane są przez okres 12 miesięcy od ostatniego kontaktu.`,
      },
      {
        heading: "4. Prawa osoby, której dane dotyczą",
        content: `Przysługują Ci następujące prawa:
- Prawo dostępu do swoich danych (art. 15 RODO)
- Prawo do sprostowania danych (art. 16 RODO)
- Prawo do usunięcia danych ("prawo do bycia zapomnianym") (art. 17 RODO)
- Prawo do ograniczenia przetwarzania (art. 18 RODO)
- Prawo do przenoszenia danych (art. 20 RODO)
- Prawo do sprzeciwu (art. 21 RODO)
- Prawo do wniesienia skargi do organu nadzorczego (Prezes UODO)

Aby skorzystać z przysługujących praw, skontaktuj się z nami mailowo.`,
      },
      {
        heading: "5. Pliki cookies",
        content: `Strona internetowa może korzystać z plików cookies (ciasteczek) w celu zapewnienia prawidłowego funkcjonowania serwisu. Cookies nie służą do identyfikacji użytkowników. Możesz wyłączyć obsługę cookies w ustawieniach przeglądarki internetowej.`,
      },
      {
        heading: "6. Udostępnianie danych",
        content: `Dane osobowe nie są sprzedawane ani przekazywane podmiotom trzecim, z wyjątkiem przypadków wymaganych prawem lub niezbędnych do realizacji usługi (np. operatorzy płatności).`,
      },
    ],
  },
  zwroty: {
    title: "Polityka Zwrotów i Anulowania",
    subtitle: "Zasady anulowania i zwrotów za szkolenia",
    sections: [
      {
        heading: "1. Anulowanie szkoleń przez uczestnika",
        content: `1. Uczestnik może anulować swój udział w szkoleniu stacjonarnym lub online na następujących warunkach:

- Anulowanie do 14 dni przed datą szkolenia: zwrot 100% wpłaconej kwoty
- Anulowanie 7-13 dni przed datą szkolenia: zwrot 50% wpłaconej kwoty
- Anulowanie do 6 dni przed datą szkolenia lub niestawienie się: brak zwrotu

2. Anulowania należy dokonać w formie pisemnej (e-mail: kontakt@fryzjerartysta.pl) z podaniem numeru zamówienia.`,
      },
      {
        heading: "2. Odwołanie szkolenia przez organizatora",
        content: `1. W przypadku odwołania szkolenia przez organizatora (z powodów niezależnych lub z powodu braku minimalnej liczby uczestników), wszystkim uczestnikom przysługuje:
- Pełny zwrot wpłaconych środków, LUB
- Możliwość przeniesienia na inny termin szkolenia

2. O odwołaniu szkolenia uczestnicy zostaną poinformowani nie później niż 3 dni przed planowanym terminem.`,
      },
      {
        heading: "3. Zwroty płatności",
        content: `1. Zwroty realizowane są w terminie do 14 dni roboczych od daty potwierdzenia prawa do zwrotu.

2. Zwrot następuje tą samą metodą płatności, którą dokonano zakupu (przelew bankowy na konto wskazane przez uczestnika).

3. W przypadku szkolenia online - dostęp do materiałów zostaje dezaktywowany w momencie przetworzenia zwrotu.`,
      },
      {
        heading: "4. Reklamacje szkoleń",
        content: `1. Reklamacje dotyczące szkoleń można składać w terminie 7 dni od daty ukończenia szkolenia.

2. Reklamację należy przesłać na adres: kontakt@fryzjerartysta.pl z tytułem "Reklamacja szkolenia [nazwa]".

3. Organizator rozpatruje reklamację w terminie 14 dni roboczych od jej otrzymania.

4. W przypadku uzasadnionej reklamacji, uczestnikowi przysługuje zwrot kosztów lub dostęp do następnego szkolenia bez dodatkowych opłat.`,
      },
      {
        heading: "5. Przeniesienie uczestnictwa",
        content: `1. Uczestnik może przenieść swoje prawo do uczestnictwa w szkoleniu na inną osobę, pod warunkiem poinformowania organizatora co najmniej 48 godzin przed datą szkolenia.

2. Przeniesienie jest bezpłatne i nie wymaga zgody organizatora, jedynie powiadomienia.`,
      },
      {
        heading: "6. Przepisy prawa",
        content: `Niniejsza polityka zwrotów jest zgodna z obowiązującymi przepisami prawa polskiego oraz ustawy z dnia 30 maja 2014 r. o prawach konsumenta. W sprawach nieuregulowanych stosuje się przepisy Kodeksu Cywilnego.`,
      },
    ],
  },
};

const LEGAL_NAV = [
  { to: "/regulamin", label: "Regulamin" },
  { to: "/polityka-prywatnosci", label: "Polityka Prywatności" },
  { to: "/polityka-zwrotow", label: "Polityka Zwrotów" },
];

export default function LegalPage({ type }) {
  const page = PAGES[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  if (!page) return null;

  return (
    <div className="bg-brand-base min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div style={{ background: "radial-gradient(circle at 30% 50%, rgba(139,0,255,0.06) 0%, transparent 60%)" }} className="absolute inset-0" />
        </div>
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p className="font-outfit text-xs uppercase tracking-[0.3em] text-violet-400 mb-3">Dokumenty Prawne</p>
            <h1 className="font-anton text-5xl md:text-7xl text-white uppercase leading-none mb-3">{page.title}</h1>
            <p className="text-white/40 text-sm">{page.subtitle}</p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 pb-24">
        <div className="grid lg:grid-cols-[240px_1fr] gap-12">
          {/* Sidebar nav */}
          <aside className="lg:sticky lg:top-28 h-fit">
            <p className="text-white/25 text-xs uppercase tracking-[0.2em] mb-4">Inne dokumenty</p>
            <nav className="space-y-2">
              {LEGAL_NAV.map(l => (
                <Link key={l.to} to={l.to}
                  className={`block py-2.5 px-4 text-sm transition-all border-l-2 ${
                    l.to === `/${type === "prywatnosc" ? "polityka-prywatnosci" : type === "zwroty" ? "polityka-zwrotow" : "regulamin"}`
                      ? "border-violet-600 text-white bg-violet-600/5"
                      : "border-white/5 text-white/40 hover:text-white hover:border-white/20"
                  }`}>
                  {l.label}
                </Link>
              ))}
            </nav>

            <div className="mt-8 border border-white/5 p-5" style={{ background: "#0A0A0A" }}>
              <p className="text-white/40 text-xs leading-relaxed mb-3">
                Pytania dotyczące regulaminu lub polityki prywatności?
              </p>
              <Link to="/kontakt" className="text-violet-400 text-xs hover:text-white transition-colors">
                Napisz do nas
              </Link>
            </div>
          </aside>

          {/* Content */}
          <main data-testid="legal-content">
            <div className="mb-8 pb-6 border-b border-white/5">
              <p className="text-white/30 text-xs">
                Ostatnia aktualizacja: styczeń 2025
              </p>
            </div>

            <div className="space-y-10">
              {page.sections.map((section, i) => (
                <motion.section key={i}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}>
                  <h2 className="font-outfit font-semibold text-white text-lg mb-4 flex items-center gap-3">
                    <span className="w-1 h-5 bg-violet-600 flex-shrink-0" />
                    {section.heading}
                  </h2>
                  <div className="text-white/60 text-sm leading-relaxed whitespace-pre-line pl-4 border-l border-white/5">
                    {section.content}
                  </div>
                </motion.section>
              ))}
            </div>

            {/* Bottom note */}
            <div className="mt-16 border border-white/5 p-6" style={{ background: "#0A0A0A" }}>
              <p className="text-white/30 text-xs leading-relaxed">
                Niniejsze dokumenty mają charakter informacyjny. W przypadku pytań lub wątpliwości prosimy o{" "}
                <Link to="/kontakt" className="text-violet-400 hover:text-white transition-colors">
                  kontakt bezpośredni
                </Link>
                . Fryzjer Artysta - Milena Bachara, Tarnów, ul. Reymonta 25, 33-100 Małopolska.
              </p>
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
}
